<template>
  <div class="ushk-content">
    <div class="ushk-main ushk-content-box">
      <div class="ushk-report">
        <div class="ushk-report__h">
          <jin-tabs v-model="tabActive" class="ushk-report-tab">
            <jin-tab-pane label="美股目标价" name="us">
              <report-content type="us" @show-report="showReport"/>
            </jin-tab-pane>
            <jin-tab-pane label="港股目标价" name="hk">
              <report-content v-if="initHkTab" type="hk" @show-report="showReport"/>
            </jin-tab-pane>
          </jin-tabs>
        </div>
      </div>
    </div>
    <div class="ushk-side">
      <div class="ushk-side__wrap">
        <ad :paddingTop="false"></ad>
        <Declatration></Declatration>
        <contract></contract>
      </div>
    </div>
    <report-dialog v-if="curData" v-model="isShowDialog" :data="curData" :type="curType"/>
  </div>

</template>
<script>
  import {
    requestUrl
  } from '@/commons/config'
  import {
    dateFormat,
    getQueryString,
    addScript
  } from '@/commons/utils'
  export default {
    data () {
      return {
        tabActive: 'us',
        curData: null,
        curType: null,
        isShowDialog: false,
        initHkTab: false
      }
    },
    watch: {
      tabActive (v) {
        if (!this.initHkTab && v === 'hk') {
          this.initHkTab = true
        }
      }
    },
    methods: {
      showReport ({ data, type }) {
        this.curData = data
        this.curType = type
        this.isShowDialog = true
      }
    }
  }

</script>



// WEBPACK FOOTER //
// home.vue?cb6f52e8